import LoadBoardLoadsListContainer from "../../components/load-board/LoadBoardLoadsList";

export default function LoadBoard() {
  return <LoadBoardLoadsListContainer />;
}
